import React, { Component } from "react";
import { Text } from "@chakra-ui/react";
import Card from "components/Card/Card";
import Chart from "react-apexcharts";
import { barChartData, barChartOptions } from "variables/charts";

class BarChart extends Component {
	constructor(props) {
		super(props);
		this.state = {
			chartData: [],
			chartOptions: {},
		};
	}

	componentDidMount() {
		this.setState({
			chartData: barChartData,
			chartOptions: barChartOptions,
		});
	}

	render() {
		return (
			<Card
				py="1rem"
				height={{ sm: "400px", md: "600px", lg: "600px", xl: "800px" }}
				width="100%"
				bg="#33333B"
				position="relative"
			>
				<Text fontSize="34px" mb={3}>
					Usage over Time
				</Text>
				<Chart
					options={this.state.chartOptions}
					series={this.state.chartData}
					type="bar"
					width="100%"
					height="90%"
				/>
			</Card>
		);
	}
}

export default BarChart;
